import { unpurry } from "@suse-o11y/unpurry";
import { take as take_ } from "remeda";

export const take = unpurry(take_, 2);
